export default __webpack_public_path__ + "5e63d972545b51047068ca350729db75.png";